@import (reference) '../../constants/spacing.module.less';

.contact-info-field-container {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.contact-info-field-icon {
  color: var(--default--icon--fill-color--3);
  height: 16px;
  width: 16px;
  flex: none;
}

.contact-info-field-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-button {
  flex: none;
  color: var(--primary--link--fill-color--2);
  height: 20px;
  width: 20px;
}
